import { Injectable } from '@angular/core';
import { MenuItem } from '../types/menu-item.type';
import { AuthService } from './auth.service';
import { Observable, of } from 'rxjs';
import { User } from '../models/user.model';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private readonly sAdmin: number = 100;
  private readonly admin: number = 80;
  private readonly serviceTechnical: number = 20;
  private readonly user: number = 0;

  //currentUser: any = this.authService.user;


  menuList: MenuItem[] = [
    {
      matIcon: "group",
      label: "Użytkownicy",
      href: '/users-list',
      permission: this.admin,
    },
    {
      matIcon: "domain",
      label: "Organizacje",
      href: '/organizations-list',
      permission: this.admin,
    },
    {
      matIcon: "group_work",
      label: "Lista maszyn",
      href: '/rekbots-list',
      permission: this.user

    },
    {
      matIcon: 'message',
      label: 'Statusy maszyn',
      href: '/rekbot-status-types',
      permission: this.sAdmin
    },
    {
      matIcon: "note",
      label: "Produkty",
      href: '/products-list',
      permission: this.admin

    },
    // {
    //   matIcon: "note_add",
    //   label: "Produkty do akceptu",
    //   href: '/temp-products-list',
    //   permission: ['admin', 'superadmin', 'user']
    // },
    {
      matIcon: "local_post_office",
      label: "SMTP",
      href: '/settings-smtp-list',
      permission: this.sAdmin

    },
    {
      matIcon: "credit_card",
      label: "Karty serwisowe",
      href: '/service-cards',
      permission: this.sAdmin

    },
    {
      matIcon: "settings_input_component",
      label: "Integracje",
      href: '/integrations',
      permission: this.sAdmin

    },
    {
      matIcon: "widgets",
      label: "Dashboard",
      href: '/dashboard',
      permission: this.admin

    },

  ];

  constructor(
    private authService: AuthService,
    private permissionsService: PermissionsService
  ) { }

  getMenu() {
    if (this.authService.user === null) {
      return null;
    } else {
      const userPermissions = this.permissionsService.getUserPermissions(this.authService.user);
      // console.log("User permissions: ", userPermissions);
      return this.menuList.filter(item => item.permission <= userPermissions);
    }
  }
}
